import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { debounceTime } from 'rxjs';
import { Page } from 'src/app/classes/page';
import { AuditService } from 'src/app/services/audit.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CommonService } from 'src/app/services/common.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-add-new-member',
  templateUrl: './add-new-member.component.html',
  styleUrls: ['./add-new-member.component.scss']
})
export class AddNewMemberComponent {
  filterControl = new FormControl('');
  editMode: boolean = false;
  itemsPerPage = 10; // Number of items per page
  currentPage = 1; // Current active page
  totalPages = 0; // Total pages
  rows: any[] = [];
  columns: any[] = [];
  userId: any;
  isBlockVisible: boolean = true;
  isDesignation: boolean = true;
  searchMemberText: string = '';
  errorMessage: string = '';
  MasterData: any[] = [];
  districts: any[] = [];
  blocksData: any;
  circlesData: any[] = [];
  designationsData: any[] = [];
  userData: any[] = [];
  memberListData: any[] = [];
  filteredMemberData: any[] = [];
  paginatedData: any[] = [];
  page = new Page();
  loading = false;

  newMember: any = {
    confirmPassword: '',
    password: '',
    userTypeId: 0,
    blockId: 0,
    circleId: 0,
    designationId: 0,
    experience: '',
    name: '',
    mobile: '',
    emailId: '',
    districtId: 0,
    address: '',
    userId: 0
  };
  roleID: any;
  constructor(private authService: AuthService, private commonService: CommonService,
    private auditService: AuditService, private toastService: ToastService,
    private route: ActivatedRoute, private ngxUiLoaderService: NgxUiLoaderService,
    private router: Router) {
    {
      this.page.pageNumber = 0;
      this.page.pageSize = 10;
    }
  }

  ngOnInit(): void {
    this.getMasterData();
    this.bindMemberDetail({ offset: 0 });
    this.bindDistrict(0);
    this.filterControl.valueChanges
      .pipe(debounceTime(300))
      .subscribe((value: any) => {
        if (value == '') {
          this.bindMemberDetail({ offset: 0 });
          return
        }
        this.applyFilter(value)
      });
    this.roleID = this.authService.currentUserValue.roleId;
    this.columns = [

      { prop: 'name', name: 'User Name' },
      { prop: 'mobile', name: 'Mobile No.' },
      { prop: 'emailId', name: 'Email Id' },
      { prop: 'desig', name: 'Designation' },
      { prop: 'sDistrictName', name: 'District Name ' },
      { prop: 'sBlockName', name: 'Block' },
      { prop: 'sCircleName', name: 'Circle' },

    ];
  }
  allowOnlyAlphabets(event: KeyboardEvent) {
    const char = String.fromCharCode(event.keyCode || event.which);
    const pattern = /^[A-Za-z\s]*$/;
    if (!pattern.test(char)) {
      event.preventDefault();
    }
  }

  selectedStatus: string = '';

  onStatusChange(status: any) {
    this.selectedStatus = status;
    this.applyFilter(this.filterControl.value || '');
  }

  filterRows: any;
  value: any;
  applyFilter(searchText: string) {
    const filter = searchText.toLowerCase().trim();

    const filtered = this.filterRows.filter((user: any) => {
      return [
        user?.districtId,
        user?.blockId,
        user?.userId?.toString(),
        user?.designationId,
        user?.desig,
        user?.designation,
        user?.experience,
        user?.userTypeId,
        user?.name,
        user?.mobile,
        user?.emailId,
        user?.address,
        user?.sCircleName,
        user?.sBlockName,
        user?.sDistrictName,
        user?.password,
        user.isActive
      ].some(field =>
        field?.toString().toLowerCase().includes(filter.toLowerCase())
      );
    });


    this.rows = [...filtered]
    this.page.totalRecords = filtered.length;
  }
  toggleUserStatus(row: any) {
    const userId = row.userId;
    this.ngxUiLoaderService.start();
    let action: string = 'DeActiveUser';

    this.commonService.deActiveUser(userId, action).subscribe({
      next: (response) => {
        if (response.status === 200) {
          row.isActive = !row.isActive;

          if (row.isActive) {
            this.toastService.showSuccess('User Activated Successfully!');
          } else {
            this.toastService.showSuccess('User Deactivated Successfully!');
          }
        } else {
          this.toastService.showError(response?.message || 'Something went wrong');
        }
        this.ngxUiLoaderService.stop();
      },
      error: (error) => {
        this.ngxUiLoaderService.stop();
        console.error('Error toggling user status:', error);
        this.toastService.showError('Failed to update user status.');
      },
    });
  }

  onUserTypeChange(event: Event): void {
    const selectedId = Number((event.target as HTMLSelectElement).value); // Convert to number
    if (selectedId === 12 || selectedId === 19 || selectedId === 10) {
      this.isBlockVisible = false;
      this.isDesignation = false;
    } else {
      this.isBlockVisible = true;
      this.isDesignation = true;
    }
  }


  submitForm(memberForm: NgForm): void {
    const payload = {
      userTypeId: this.newMember.userTypeId ? Number(this.newMember.userTypeId) : null,
      districtId: this.newMember.districtId ? Number(this.newMember.districtId) : null,
      circleId: this.newMember.circleId ? Number(this.newMember.circleId) : null,
      blockId: this.newMember.blockId ? Number(this.newMember.blockId) : null,
      designationId: this.newMember.designationId ? Number(this.newMember.designationId) : null,
      userId: this.userId ? this.userId : 0,
      mobile: this.newMember.mobile || '',
      name: this.newMember.name || '',
      emailId: this.newMember.emailId || '',
      password: this.newMember.password || '',
      confirmPassword: this.newMember.confirmPassword || '',
      address: this.newMember.address || '',
      experience: this.newMember.experience || ''
    };

    this.auditService.addMember(payload).subscribe(
      (res) => {
        if (res.status === 200) {
          this.toastService.showSuccess(res.message);
          memberForm.resetForm();
          this.bindMemberDetail({ offset: 0 });
        }
      },
      (err) => {
        this.toastService.showError(err.message);
        console.error('API error:', err);
      }
    );
  }


  bindMemberDetail(pageInfo: any): void {

    this.loading = true;
    this.page.pageNumber = pageInfo.offset;
    const requestParams = {
      pageSize: this.page.pageSize,
      pageNumber: this.page.pageNumber
    }
    this.auditService.getMemberDetail(requestParams).subscribe(
      (response) => {
        if (response.status === 200) {
          this.loading = false;

          this.rows = response.data;
          this.filterRows = response.data;


          this.page.totalRecords = response.totalRecords;
        }
      },
      (error) => {
        console.error('Error fetching members:', error);
      }
    );
  }
  filterMemberTable() {
    this.bindMemberDetail({ offset: 0 });

  }

  filterList(list: any[], searchText: string, keys: string[]): any[] {
    if (!searchText) return list;

    searchText = searchText.toLowerCase();

    return list.filter((item) =>
      keys.some((key) =>
        item[key]?.toString().toLowerCase().includes(searchText)
      )
    );
  }

  validateMobile(event: any): void {
    let input = event.target.value;
    // input = input.replace(/\D/g, '');
    if (input.length > 10) {
      input = input.slice(0, 10);
    }
    event.target.value = input;
    this.newMember.mobile = input;
  }
  isEmailValid: boolean = true;

  validateEmail(event: any): void {
    const value = event.target.value;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    this.isEmailValid = emailPattern.test(value);
  }


  bindDistrict(iDistrictID: number): void {
    this.auditService.bindDistrict(iDistrictID).subscribe(
      (response) => {
        if (response.status === 200) {
          this.districts = response.lstDistrict;
        } else {

          this.toastService.showError(response.message);
        }
      },
      (error) => {
        // Handle any errors that occur during the request
        this.errorMessage = 'Error fetching dropdown data: ' + error.message;
        console.error('Error fetching dropdown data:', error);
      }
    );
  }

  onDistrictChange(event: Event) {

    const iDistrictID = Number((event.target as HTMLSelectElement).value);
    this.newMember.circleId = 0;

    this.auditService.bindDistrict(iDistrictID).subscribe(
      (response) => {

        if (response.status === 200) {
          this.circlesData = response.lstCircle;
        } else {
          this.toastService.showError(response.message);
        }
      },
      (error) => {
        // Handle any errors that occur during the request
        this.errorMessage = 'Error fetching dropdown data: ' + error.message;
        console.error('Error fetching dropdown data:', error);
      }
    );
  }

  onCircleChange(event: Event) {
    const iDistrictID = this.newMember.districtId;
    this.newMember.blockId = 0;
    this.blocksData = [];

    if (!iDistrictID) return;

    this.auditService.bindDistrict(iDistrictID).subscribe(
      (response) => {
        if (response.status === 200) {
          this.blocksData = response.lstBlock || [];
        } else {
          this.toastService.showError(response.message);
        }
      },
      (error) => {
        this.errorMessage = 'Error fetching dropdown data: ' + error.message;
        console.error('Error fetching dropdown data:', error);
      }
    );
  }



  getMasterData(): void {
    this.auditService.getAssignedDropDownValues().subscribe(
      (response) => {

        if (response.status === 200) {
          this.userData = response.data.users;
          this.designationsData = response.data.designations;
        } else {

          this.toastService.showError(response.message);
        }
      },
      (error) => {
        // Handle any errors that occur during the request
        this.errorMessage = 'Error fetching dropdown data: ' + error.message;
        console.error('Error fetching dropdown data:', error);
      }
    );
  }





  editMember(row: any): void {


    this.editMode = true;
    this.userId = row.userId;
    this.newMember.userTypeId = row.userTypeId;
    this.newMember.name = row.name;
    this.newMember.districtId = row.districtId;
    this.newMember.address = row.address;
    this.newMember.designationId = row.designationId;
    this.newMember.experience = row.experience;
    this.newMember.circleId = row.circleId ? row.circleId : 0;
    this.newMember.blockId = row.blockId ? row.blockId : 0;


  }


}
